import { updateImageLayout } from "Ifloorplan/redux/actions/actions";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import KenBurnsImage from "../KenBurnsImage";

const ImageSlider = (props) => {
    useEffect(() => {
        let image = new Image();
        image.onload = (image) => {
            const width = image.target.width;
            const height = image.target.height;
            const placeHolderRatio =
                props.place_holder_layout.width / props.place_holder_layout.height;
            let layout = {};
            if (width / height > placeHolderRatio) {
                layout = {
                    width: `${props.place_holder_layout.width}px`,
                    height: `${(props.place_holder_layout.width / width) * height}px`,
                    transform: `translateY(${
                        (props.place_holder_layout.height -
                            (props.place_holder_layout.width / width) * height) /
                        2
                    }px)`,
                };
            } else {
                layout = {
                    width: `${(props.place_holder_layout.height / height) * width}px`,
                    height: `${props.place_holder_layout.height}px`,
                    transform: `translateX(${
                        (props.place_holder_layout.width -
                            (props.place_holder_layout.height / height) * width) /
                        2
                    }px)`,
                };
            }

            props.updateImageLayout(layout, props.index);
        };
        image.src = props.src;
    }, [props.place_holder_layout]);

    const isMobile = props.isPortrait || props.isLandscape;

    return props.kenburns ? (
        <KenBurnsImage
            img={props.src}
            active={props.index == props.currentIndex}
            kenBurnsZoom={props.kenBurnsZoom}
            current={props.currentIndex}
            setFinishLoadImage={props.setFinishLoadImage}
        />
    ) : isMobile ? (
        <div className="image" style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", overflow: "hidden"}}>
            <img
                src={props.src}
                style={{maxWidth: "100%", maxHeight: "100%", objectFit: "contain", display: "block"}}
                onLoad={(e) => {
                    e.target.decode().then(() => props.setFinishLoadImage(true)).catch(() => props.setFinishLoadImage(true));
                }}
            />
        </div>
    ) : (
        <div className="image">
            <img
                src={props.src}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
                onLoad={(e) => {
                    e.target.decode().then(() => props.setFinishLoadImage(true)).catch(() => props.setFinishLoadImage(true));
                }}
            />
        </div>
    );
};

const putState = (state) => {
    return {
        image_layout: state.image_layout,
        place_holder_layout: state.place_holder_layout,
    };
};

const putDispatch = (dispatch) => {
    return {
        updateImageLayout: (imageLayout, index) =>
            dispatch(updateImageLayout(imageLayout, index)),
    };
};

export default connect(putState, putDispatch)(ImageSlider);